import React from "react";
import "./Skeleton.css"

const Skeleton = () => {

  return (
    <div className="app_main mt-5">
        {/* <div className="header_skeleton">
            <div className="load_skeleton avatar"></div>
            <div className="head info"></div>
        </div> */}
        <div className="banner info"></div>
        <div className="header_skeleton row mt-5">
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
        </div>
        <div className="header_skeleton row">
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
        </div>
        <div className="header_skeleton header_next_skeleton row mt-5">
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
            <div className="col-md-4">
                <div className="rentBox info"></div>
            </div>
        </div>
        {/* <div className="main_skeleton mt-5">
            <div className="load_skeleton sidebar_skeleton"></div>
            <div className="inner_skeleton">
                <div className="items_skeleton">
                    <div className="load_skeleton item"></div>
                    <div className="load_skeleton item"></div>
                    <div className="load_skeleton item"></div>
                </div>
            </div>
        </div> */}
    </div>
  )
}

export default Skeleton
